import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column } from '@pella/sash-framework';
import { Image, CTA } from '../../';

import styles from './index.module.scss';

const ProductSeries = ({ data, align }) => {
	if (!data) return null;

	return (
		<div id={data.anchor || null}>
			{data.image?.[0] && (
				<div className={`${styles.series_ImageWrapper} ${align === 'top' && styles.series_alignTop}`}>
					<Image
						data={data.image[0]}
						className={styles.series_Image}
					/>
					<Container fluid>
						<div className={styles.series_Box}>
							{data.subheading && (
								<div
									className={styles.series_Subtitle}
									dangerouslySetInnerHTML={{
										__html: data.subheading,
									}}
								/>
							)}
							{data.heading && (
								<h2
									className={styles.series_Title}
									dangerouslySetInnerHTML={{
										__html: data.heading,
									}}
								/>
							)}
						</div>
					</Container>
				</div>
			)}

			<div className={styles.series_Content}>
				<Container>
					<Row
						verticalGutters={true}
						largeGutters={true}
					>
						{data.content?.[0] &&
							data.content.map((item, index) => (
								<Column
									key={index}
									xs={12}
									md={4}
								>
									{item.heading && <h3>{item.heading}</h3>}
									{item.description && (
										<div
											dangerouslySetInnerHTML={{
												__html: item.description,
											}}
										/>
									)}
									{item.ctas?.[0] && <CTA data={item.ctas[0]} />}
								</Column>
							))}
					</Row>
				</Container>
			</div>
		</div>
	);
};

ProductSeries.propTypes = {
	data: PropTypes.object,
	reserve: PropTypes.bool,
	align: PropTypes.string,
};

export default ProductSeries;
